import { createContext, ReactNode, useContext } from 'react';
import { SendApiRequest } from '@inbox-demo-nx/types';

export const APIContext = createContext<{
  sendApiRequest: SendApiRequest;
}>({} as any);

export const APIContextProvider = ({
  children,
  sendApiRequest,
}: {
  children: ReactNode;
  sendApiRequest: SendApiRequest;
}) => {
  return (
    <APIContext.Provider value={{ sendApiRequest }}>
      {children}
    </APIContext.Provider>
  );
};

export const useSendApiRequest = () => useContext(APIContext).sendApiRequest;
